<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <img src="logo.png" alt="logo" style="width: 80%;">
        <!-- <h1 class="nome-autoescola text-center">{{projeto}}</h1> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vuestic-icon-vuestic',
  data() {
    return {
      projeto: process.env.VUE_APP_NOME_PROJETO
    }
  }
}
</script>

<style lang="scss">
  .vuestic-icon-vuestic {
    display: inline-block;
    width: 129px;
    height: 15.4px;
    .st0 {
      fill: #4AE387;
    }
  }

  .nome-autoescola {
    font-size: 46px;
    font-weight: bold;
    color: #4AE387;
  }

</style>
